import type { EditorState } from '../store/editorState';

const getHoveredComp = (state: EditorState) => state.hoverBox.hoveredComp;
const getHoverBoxOverlay = (state: EditorState) =>
  state.hoverBox.hoverBoxOverlay;

export { getHoverBoxOverlay, getHoveredComp };
